import React, { useState } from "react";
import {
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  Chip,
  IconButton,
} from "@material-ui/core";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import RefreshIcon from "@material-ui/icons/Refresh";
import CompareArrowsIcon from "@material-ui/icons/CompareArrows";
import CachedIcon from "@material-ui/icons/Cached";

import { leerHistorial } from "./startClocksHistoryStorage";

const ACCION_INFO = {
  iniciar: { label: "Iniciado", color: "#2e7d32", Icon: PlayArrowIcon },
  reiniciar: { label: "Reiniciado", color: "#c62828", Icon: RefreshIcon },
  igualar: { label: "Igualado", color: "#ff8f00", Icon: CompareArrowsIcon },
};

function formatearHora(timestamp) {
  if (!timestamp) return "—";
  return new Date(timestamp).toLocaleString();
}

export default function StartClocksHistoryView({ eventoIndex }) {
  const [registros, setRegistros] = useState(() => leerHistorial(eventoIndex));

  function refrescar() {
    setRegistros(leerHistorial(eventoIndex));
  }

  const ordenados = [...registros].sort((a, b) => b.movimientoTs - a.movimientoTs);

  return (
    <div style={{ padding: "30px", minWidth: "400px" }}>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          <Typography variant="h5">Historial de movimientos</Typography>
        </Grid>
        <Grid item>
          <IconButton onClick={refrescar}>
            <CachedIcon />
          </IconButton>
        </Grid>
      </Grid>

      {ordenados.length === 0 && (
        <Typography color="textSecondary" style={{ marginTop: 16 }}>
          Todavía no hay movimientos registrados en este dispositivo.
        </Typography>
      )}

      <List>
        {ordenados.map((registro, index) => {
          const info = ACCION_INFO[registro.accion] || {};
          const Icon = info.Icon;
          return (
            <ListItem key={index} divider>
              <ListItemText
                primary={`${registro.descModalidad} - ${registro.descSerie}`}
                secondary={`Hora de inicio: ${formatearHora(
                  registro.hsTimestamp
                )}  ·  Movimiento: ${formatearHora(registro.movimientoTs)}`}
              />
              <Chip
                icon={Icon ? <Icon style={{ color: "#fff" }} /> : undefined}
                label={info.label || registro.accion}
                style={{ backgroundColor: info.color, color: "#fff" }}
              />
            </ListItem>
          );
        })}
      </List>
    </div>
  );
}
